var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"milestone-plan-state"},[_c('div',{staticClass:"milestone-plan-state__cell",style:(_vm.cellStyles)}),_c('h3',{staticClass:"milestone-plan-state__title",style:(_vm.textStyles)},[_vm._v(" "+_vm._s(_vm.stateCopy)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }